export const visualizarMetas = 'VisualizarMetas';
export const configurarNovaMeta = 'ConfigurarNovaMeta';
export const excluirMeta = 'ExcluirMeta';

export const configurarModeloNivel = 'ConfigurarModeloNivel';
export const aplicarModeloNivel = 'AplicarModeloNivel';
export const excluirModeloNivel = 'ExcluirModeloNivel';
export const listarModelosNivel = 'ListarModelosNivel';
export const listarNiveisMeta = 'ListarNiveisMeta';

export const estagioConfiguracao = 'EstagioConfiguracao';
export const exportarModeloMeta = 'ExportarModeloMeta';
export const importarModeloMeta = 'ImportarModeloMeta';
export const metas = {
  configurar: [visualizarMetas, aplicarModeloNivel, excluirModeloNivel, listarModelosNivel, listarNiveisMeta, configurarNovaMeta, excluirMeta],
  exportar: [exportarModeloMeta],
  importar: [importarModeloMeta],
  estagio: [estagioConfiguracao]
};
